import React from "react";
import { Operator, OperatorTypes } from "@merrie/nmbrs-api";

export interface IOperatorProperties {
  operator: Operator;
}

export const OperatorComponent: React.FC<IOperatorProperties> = ({
  operator,
}) => {
  switch (operator.operator) {
    case OperatorTypes.ADD:
      return <span className={"operator"}>+</span>;
    case OperatorTypes.DIVIDE:
      return <span className={"operator"}>/</span>;
    case OperatorTypes.MULTIPLY:
      return <span className={"operator"}>*</span>;
    case OperatorTypes.SUBTRACT:
      return <span className={"operator"}>-</span>;
    default:
      return null;
  }
};
